// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"1a7bf78d","208":"2d2ae0dd","315":"db057b07","409":"0ef446e5","631":"d7e590e3","774":"012b42f5","805":"5a840b67"}[chunkId] + ".chunk.js";
};